/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */

export const scrollToPlusNav = (element) => {
  if (typeof window !== 'undefined') {
    const filters = document.querySelector(element);
    const filtersBounds = filters.getBoundingClientRect();
    const navBar = document.querySelector('.navbar');
    window.scrollTo({
      top: (filtersBounds.top + window.pageYOffset) - navBar.offsetHeight,
      behavior: 'smooth',
    });
  }
};
